import { sagas as inspectionsSagas } from './modules/inspections'

export default [...inspectionsSagas]
